import 'intersection-observer';
// 节流时间调整，默认100ms
IntersectionObserver.prototype['THROTTLE_TIMEOUT'] = 300;


export default class Exposure{
  constructor(){
    this._observer = null
    this.init()
  }
  init(){
    let self = this;
    self._observer = new IntersectionObserver((entries, observer)=>{
      entries.forEach((entry)=>{
        if(entry.isIntersecting){
          const tp = entry.target.attributes['track-params'].value;
          if(entry.target.attributes['track-name']){
            const name = entry.target.attributes['track-name'] ? entry.target.attributes['track-name'].value : ''; 
            self.trackName(JSON.parse(tp,name),name);
          }else{
            self.track(JSON.parse(tp));
          }
        
          self._observer.unobserve(entry.target);
        }
      })
    },{
      root: null,
      rootMargin: '0px',
      threshold: 0.5 // 元素出现面积，0 - 1，
    })
  }
   /**
   * 给元素添加监听
   * @param {Element} entry 
   */
  add(entry) {
    this._observer && this._observer.observe(entry.el)
  }
  track(tp){
    gio("track", "moduleExposure", {indexId_var: tp.id, entryType_vara:'首页', entryType_floor_var: tp.sort});
    gio("track","adProductExposure",{position_var:'斯凯奇特特卖',advertisementID_var:tp.code,productName_var:'',productID_var:""})
  }
  trackName(tp,name){
    if(name =='searchBeeExposure'){
      tp.searchSource_var = tp.searchSource_var =='index'?'首页':'商品详情页'
      gio("track",'searchBeeExposure',tp)
    }
    if(name =='searchProductExposure'){
      let isShear = window.sessionStorage.getItem('ifsearch') ? JSON.parse(window.sessionStorage.getItem('ifsearch')):'y'
      tp.ifSearchResultFirstCkPt_var = isShear  && isShear.length>1?'n':'y'
      gio("track",'searchProductExposure',tp)
    }else{
      gio("track", name, {Source_var:'推荐页面',moduleType_var:'推荐主页',productName_var: tp.itemName,productID_var:tp.refId,
      storeID_var:tp.branchNo,storeName_var:tp.branchName});
    }
  

  }

}